module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/cowork-3-a802c912424bacc0a256a14a4018f1e0.jpg";